export default __webpack_public_path__ + "1.18.19/static/media/green-check.c88ea47e.svg";